import Vue from 'vue'
import App from './App.vue'

// Install BootstrapVue
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Install VueMoney
import money from 'v-money'
Vue.use(money, { precision: 2, decimal: ',', thousands: '.', prefix: 'R$ ' })

// Install Matomo
import VueMatomo from 'vue-matomo'

Vue.use(VueMatomo, {
  host: 'https://analytics.squalotech.com.br/',
  siteId: 2,
  trackerFileName: 'matomo',
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
});


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
